<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ statInspIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <div class="md-layout-item md-small-size-100 md-size-100">
                  <label>Select date</label>
                  <md-datepicker v-model="form.reportDate" md-immediately>
                  </md-datepicker>
                </div>
                <div
                  v-show="statInsp.isPartial"
                  class="md-layout-item md-small-size-100 md-size-70"
                >
                  <md-field>
                    <label>Note</label>
                    <md-input v-model="form.partialNote" type="text"></md-input>
                  </md-field>
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
              >Submit</md-button
            >
            <md-button class="md-danger md-sm" @click="onCancel"
              >Cancel</md-button
            >
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  name: "edit-statInsp",
  data() {
    return {
      hasSubmit: false
    };
  },
  computed: {
    ...mapGetters({
      statInspIcon: "stat-insp/icon",
      statInsp: "stat-insp/statInsp"
    }),
    form() {
      return {
        reportDate: moment(this.statInsp.reportDate).format("YYYY-MM-DD"),
        partialNote: this.statInsp.partialNote
      };
    }
  },
  async created() {
    this.$material.locale.dateFormat = "yyyy-MM-dd";
    await this.$store.dispatch(
      "stat-insp/getStatInsp",
      this.$route.params.statInspId
    );
  },
  methods: {
    onCancel() {
      this.hasSubmit = false;
      this.$router.push({
        name: "Statutory Inspection",
        params: { statInspId: this.$route.params.statInspId }
      });
    },
    onSubmit() {
      this.hasSubmit = true;
      (this.form.statInspId = this.$route.params.statInspId),
        (this.form.reportDate = moment(this.form.reportDate).format(
          "YYYY-MM-DD"
        ));
      this.$store
        .dispatch("stat-insp/updateStatInsp", {
          form: this.form
        })
        .then(() => {
          this.$router.push({
            name: "Statutory Inspection",
            params: { statInspId: this.$route.params.statInspId }
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status >= 400 && error.response.status < 500) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>
